import ColorPicker from '../../../../../../../../../../components/miscellany/color_picker/color_picker'
import CollapseCard from '@components/miscellany/collapse/collapse_card'
import ToggleButton from '@components/miscellany/toggle_button/toggle_button'
import store from '@packs/pages/charts/index/components/view/edit/store'
import('./plu_config_component.css')

export default function PluConfigComponent(opts){
    BaseConstructor.call(this)
    let container = opts.container
    let elements = {}
    let context = this
    let groupDataToggleButton
    let chart_name = opts.chart_name

    this.generate = () =>{
        elements.container = this.createElement('div') //container de tudo
        elements.collapse_card_content = context.createElement('div') //conteudo do collapse
        elements.color_picker_container = context.createElement('div') //colorpicker
        elements.color_picker = context.createElement('div') //colorpicker
        elements.group_data_container = context.createElement('div')
        elements.group_data = context.createElement('div')


        $(elements.color_picker_container).append(elements.color_picker)
        $(elements.group_data_container).append(elements.group_data)

        generateCollapse()
        generateColorPicker()
        generateGroupDataOption()
        
        $(elements.collapse_card_content).append(elements.color_picker_container, elements.group_data_container)

        $(container).append(elements.container)
    }

    this.update = () =>{

    }

    function generateGroupDataOption(){
        let label = context.createElement('label', '', 'Agrupar dados <i class="fas fa-question-circle"></i>')
        $(elements.group_data_container).prepend(label)

        tippy(label, {
            placement:'top',
            theme: 'material',
            animation: 'shift-away',
            content: 'Caso múltiplos dados na mesma data e hora, será apresentada a média'
        })

        let current = store.getChartNestedProp(chart_name, 'series.rain.options.grouped') === 'true'
        groupDataToggleButton = new ToggleButton({container: elements.group_data, custom_class:'plu-config-group-button',states:[
            {title: 'NÃO', active: !current, id:'no', classList:''},
            {title: 'SIM', active:current, id: 'yes', classList:'active'}
        ]})
        groupDataToggleButton.generate()

        groupDataToggleButton.on('click', states=>{
            store.setChartNestedProp(chart_name, 'series.rain.options.grouped', states.toState.id == 'yes')
        })
    }

    function generateCollapse(){
        
        let collapse = new CollapseCard(
            {title_options:{text:'CONFIGURAÇÕES', icon_options:{}}, 
            content_options:{content: elements.collapse_card_content}
        })

        $(elements.container).append(collapse.generate())
    }

    function generateColorPicker(){
        let label = context.createElement('label', '', 'Cor')
        $(elements.color_picker_container).prepend(label)

        let current = store.getChartNestedProp(chart_name, 'series.rain.options.series_color')
        let colorPicker = new ColorPicker({container:elements.color_picker, current_color: current})
        colorPicker.generate()

        colorPicker.on('change', data=>{
            // 'color' é um objeto Color da lib Pickr
            store.setChartNestedProp(chart_name, 'series.rain.options.series_color', data.color.toHEXA().toString())
        })
    }
}

PluConfigComponent.prototype = Object.create(BaseConstructor.prototype)